import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {
    getAllLineStations,
    getLineStationsByLineIdApi,
    insertLineStationApi,
    updateLineStationApi
} from "../../api/backendAPIs";

export const fetchLineStationsByLineId = createAsyncThunk('fetchLineStationsByLineId', async (lineId) => {
    return getLineStationsByLineIdApi(lineId)
})

export const fetchAllLineStations = createAsyncThunk('fetchAllLineStations', async () => {
    return getAllLineStations()
})

export const insertLineStation = createAsyncThunk('insertLineStationApi', async (payload) => {
    return insertLineStationApi(payload)
})

export const updateLineStation = createAsyncThunk('updateLineStationApi', async (payload) => {
    return updateLineStationApi(payload)
})

const initialState = {
    lineStations: [],
    loadingLineStations: false,
}

export const lineStationsSlice = createSlice({
    name: 'lineStations',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchLineStationsByLineId.pending]: (state) => {
            state.loadingLineStations = true;
        },
        [fetchLineStationsByLineId.fulfilled]: (state, {payload}) => {
            state.loadingLineStations = false;
            state.lineStations = payload.data.content;
        },
        [fetchLineStationsByLineId.rejected]: (state) => {
            state.loadingLineStations = false;
        },
        [fetchAllLineStations.pending]: (state) => {
            state.loadingLineStations = true;
        },
        [fetchAllLineStations.fulfilled]: (state, {payload}) => {
            state.loadingLineStations = false;
            state.lineStations = payload.data.content;
        },
        [fetchAllLineStations.rejected]: (state) => {
            state.loadingLineStations = false;
        },
    }
});

export const lineStationReducer = lineStationsSlice.reducer
